import { mappingFunctionDef } from 'Modules/Studio/Mappings/redux/initialState';

export const getMatchingOverlap = (dataSetMap, conceptIdOverlaps, selectedMapping) => {
  if (!dataSetMap || !conceptIdOverlaps || !selectedMapping) {
    return [];
  }
  const selectedDataSet = dataSetMap[selectedMapping.dataSetId];
  if (!selectedDataSet) {
    return [];
  }
  const datasetID = `${selectedDataSet.dataSourceId}.${selectedDataSet.tableName}`;
  return conceptIdOverlaps.filter((id) => {
    const overlapId = `${id.dataSourceId}.${id.tableName}`;
    return overlapId === datasetID;
  });
};

/**
 * getFormDefaultsFromOverlaps - sets the selectedMapping defaults for the Concept ID tab
 * - mappingIdTypeId
 * - idColumnName
 * - idFunction,
 * @param {array} overlaps
 * @param {object} dataSetMap
 * @param {object} selectedMapping
 * @returns object
 */
export const getFormDefaultsFromOverlaps = (overlaps, dataSetMap, selectedMapping) => {
  const functionType = 'idFunction';
  let idFunction = mappingFunctionDef;

  // the two state variables being set that will set the form defaults
  let idColumnName = '';
  let mappingIdTypeId = 0;

  // set custom identifier & default settings here
  const matchingOverlap = getMatchingOverlap(dataSetMap, overlaps, selectedMapping);

  // if an overlap exists for this concept & dataset
  if (matchingOverlap.length > 0) {
    if (matchingOverlap.length > 1) {
      console.warn(
        "There are more than 1 matching overlaps; it's possible the UI will not show the expected form defaults.  Default is set to matchingOverlap[0]",
        matchingOverlap
      );
    }
    // if it's of type function, pre-populate the function
    // check to ensure it was not set to null; this happens when the user removes existing mappings for this overlap.  The BE will respond with idFunction: null and cause the app to in the isSubmitDisabled function where there's a check for selectedMapping.idFunction.column.length === 0
    if (matchingOverlap[0].idColumnType === 2 && matchingOverlap[0][functionType] !== null) {
      mappingIdTypeId = 2;
      // set local mappingDef object for the function type; this will update the UI form fields for the function that was previously set
      idFunction = matchingOverlap[0][functionType];
    } else if (matchingOverlap[0].idColumnType === 2 && matchingOverlap[0][functionType] === null) {
      // set to empty string so the user doesnt see ##function_null## which is what comes back from the BE in this error scenario
      idColumnName = '';
    } else {
      // else, set the idColumnNameInput
      idColumnName = matchingOverlap[0].idColumnName;
    }
  }

  return {
    mappingIdTypeId,
    idColumnName,
    idFunction,
    matchingOverlap: matchingOverlap?.[0] || {},
  };
};
